<template>
<SideComponent @scrollto="scroll"></SideComponent>
	<NewIndexSiteLayout>
	<div class="container" ref="viewBox">
		<div class="content">
			<div class="enclosure">
				<div class="inner">
					<div class="left">
						<SideMenu />
					</div>
					<div class="right">
						<div class="caption">
							<span>{{$t('person.personCenter')}}</span><span class="arrow"><i class="iconfont icon-jiantou2"></i></span><span>{{$t('sideMenu.apply')}}</span>
						</div>
						
						<div class="tag-outer">
							<div class="tag-item">
								<img src="@/assets/img/grapher_settled/no_pass.png"/>
							</div>
							<div class="tag-item">
								<span class="text-1">{{$t('apply_nopass.tip1')}}</span>
							</div>
							<div class="tag-item reason">
								<span class="text-2">{{$t('apply_nopass.tip2')}}</span>
							</div>
							<div class="tag-item reason">
								<span class="text-2">{{$t('apply_nopass.tip3')}}</span>
							</div>
							<div class="tag-item">
								<div class="settled-btn" @click="toApplication()">{{$t('apply_nopass.tip4')}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</NewIndexSiteLayout>
</template>

<script>
	import apply_nopass from './apply_nopass_controller';
	export default apply_nopass;
</script>

<style src="@/assets/css/my/grapher/apply_nopass.css" scoped></style>